export const EventName = {
  showLayer: 'showLayer',
  hideLayer: 'hideLayer',
  clearLayer: 'clearLayer',
  showSpin: 'showSpin',
  hideSpin: 'hideSpin',
  clearSpin: 'clearSpin',
};
